module.exports = __webpack_public_path__ + "img/auscultation.9865a518.png";